import { http } from '@/services/http';
import { toQueryParams } from '@/shared/lib/url/toQueryParams';

import type { FeedInfo } from '../types';

const group = import.meta.env.VITE_FEED_GROUP;

export const fetchFeedArticles = async (feedKeyCategories: string[]): Promise<FeedInfo[]> => {
  const params = toQueryParams({
    group,
    KeyCategory: feedKeyCategories,
    from: '1v',
    'field.Status': 'Live',
    'field.CTAType': 'Article'
  });
  const { data }: { data: FeedInfo[] } = await http.data.get(`index${params}`, {
    headers: { Accept: 'application/json' }
  });
  return data.map(feedInfo => {
    const { transactionTime } = feedInfo;
    return {
      ...feedInfo,
      transactionTime: transactionTime.includes('Z') ? transactionTime : `${transactionTime}Z`
    };
  });
};
